import { type IconProps } from 'components/Shared/Icon/index';
import { iconStyles } from 'components/Shared/Icon/iconStyles';
import styles from './styles.scss';
import cn from 'classnames';

export const IconVipps = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 400 260"
    className={cn(iconStyles(props), styles.removeStroke)}
  >
    <rect fill="#ff5b24" x="26.7" width="346.7" height="260" rx="14.4" ry="14.4" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M229.7,101.5c10.6,0,19.7-8,19.7-19.6h0c0-11.5-9.1-19.6-19.7-19.6s-19.7,8-19.7,19.6,9.1,19.6,19.7,19.6ZM255.4,133.1c-13.1,17.1-27,28.9-51.4,28.9h0c-24.9,0-44.3-15.1-59.5-37.2-6-9-15.4-11.1-22.2-6.3-6.3,4.5-7.8,14.1-2,22.3,20.9,31.9,49.9,50.5,83.7,50.5s55.2-15.1,74.1-40.2c7-9.3,6.8-18.8,0-24.1-6.3-5-15.6-3.2-22.7,6Z"
    />
  </svg>
);
